
export type GetStreamingInfoByPath200QualitiesItem = {
  /** 비트레이트 (kbps) */
  bitrate?: number;
  height?: number;
  resolution?: string;
  width?: number;
};
